
import React, {
  useState,
} from "react"

import EtUserMyInitiation
  from "./EtUserMyInitiation"

import EtUserMyIntention
  from "./EtUserMyIntention"

import EtUserLearnFromOthers
  from "./EtUserLearnFromOthers"


/*
|--------------------------------------------------------------------------
| User Initiation Workspace - 27 Sep 2026
|--------------------------------------------------------------------------
|
| Personal Initiation navigation.
|
| My Journey      - Existing onboarding and milestone journey.
| My Intention    - Submitted responses and responsiveness.
|
| Learn From Others will be added after its personal API is established.
|
*/

const EtUserInitiationWorkspace = () => {

  const [
    activeView,
    setActiveView,
  ] = useState("journey")


  const tabs = [

    {
      value: "journey",
      label: "My Journey",
    },

    {
      value: "intention",
      label: "My Intention",
    },

    {
      value: "learn",
      label: "Learn From Others",
    },

  ]


  return (

    <div className="font-poppins space-y-3">

      <div className="bg-white rounded-lg p-2">

        <div className="flex flex-wrap gap-2">

          {tabs.map(tab => (

            <button
              key={tab.value}
              type="button"
              onClick={() =>
                setActiveView(tab.value)
              }
              className={`rounded px-4 py-2 text-xs font-bold ${
                activeView === tab.value
                  ? "bg-orange-600 text-white"
                  : "bg-gray-100 text-gray-600 hover:bg-orange-50"
              }`}
            >
              {tab.label}
            </button>

          ))}

        </div>

      </div>


      {activeView === "journey" && (
        <EtUserMyInitiation />
      )}


      {activeView === "intention" && (
        <EtUserMyIntention />
      )}

      {activeView === "learn" && (
        <EtUserLearnFromOthers />
       )}

    </div>

  )

}


export default EtUserInitiationWorkspace